module.exports = __webpack_public_path__ + "image/footer-icon3.png";